import type { LobbyState, ServerMsg } from "@genjiball/protocol";

export class MatchHud {
  private root: HTMLElement;
  private countdownEl: HTMLElement;
  private killFeedEl: HTMLElement;
  private speedEl: HTMLElement;
  private diedEl: HTMLElement | null = null;
  private myId: string | null = null;
  private players: LobbyState["players"] = {};
  private countdownTimer: number | null = null;
  private countdownStartsAt: number = 0;
  private countdownDurationSec: number = 3;

  constructor() {
    this.root = document.getElementById("hud")!;
    this.countdownEl = document.createElement("div");
    this.countdownEl.id = "hud-countdown";
    this.countdownEl.hidden = true;
    this.root.appendChild(this.countdownEl);

    this.killFeedEl = document.createElement("div");
    this.killFeedEl.id = "hud-killfeed";
    this.root.appendChild(this.killFeedEl);

    this.speedEl = document.createElement("div");
    this.speedEl.id = "hud-ballspeed";
    this.speedEl.textContent = "Ball: —";
    this.root.appendChild(this.speedEl);
  }

  /** Update the ball-speed readout; pass null when there's no ball (lobby). */
  setBallSpeed(speed: number | null) {
    this.speedEl.textContent = speed === null ? "Ball: —" : `Ball: ${Math.round(speed)} m/s`;
  }

  setSelf(id: string) {
    this.myId = id;
  }

  syncLobby(lobby: LobbyState) {
    this.players = lobby.players;
  }

  onRoundStart(msg: Extract<ServerMsg, { t: "roundStart" }>) {
    this.countdownStartsAt = msg.startsAt;
    this.countdownEl.hidden = false;
    this.tickCountdown();
    if (this.countdownTimer !== null) clearInterval(this.countdownTimer);
    this.countdownTimer = window.setInterval(() => this.tickCountdown(), 100);
    this.clearDied();
  }

  private tickCountdown() {
    const now = Date.now();
    const elapsedSec = (now - this.countdownStartsAt) / 1000;
    const remaining = this.countdownDurationSec - elapsedSec;
    if (remaining <= 0) {
      this.countdownEl.textContent = "GO";
      setTimeout(() => {
        this.countdownEl.hidden = true;
        if (this.countdownTimer !== null) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 400);
      return;
    }
    this.countdownEl.textContent = String(Math.ceil(remaining));
  }

  onKill(playerId: string) {
    const name = this.players[playerId]?.name ?? "Player";
    const e = document.createElement("div");
    e.className = "killfeed-entry";
    e.textContent = `${name} was eliminated`;
    this.killFeedEl.appendChild(e);
    setTimeout(() => e.remove(), 3000);

    if (playerId === this.myId) this.showDied();
  }

  private showDied() {
    if (this.diedEl) return;
    this.diedEl = document.createElement("div");
    this.diedEl.id = "hud-died";
    this.diedEl.textContent = "ELIMINATED";
    this.root.appendChild(this.diedEl);
  }

  clearDied() {
    if (!this.diedEl) return;
    this.diedEl.remove();
    this.diedEl = null;
  }

  onRoundEnd() {
    this.clearDied();
  }
}
